module.exports = __webpack_public_path__ + "tr.28b8c158.svg";